export default class TechnologyStack {
    static init(): void {
        const triggers = document.querySelectorAll<HTMLElement>('.technology-stack-trigger');

        if (!triggers.length) return;

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', (e: Event) => {
                e.preventDefault();

                if (window.innerWidth >= 768) return;

                const item = trigger.closest<HTMLElement>('.js-technology-stack-item');

                if (!item) return;

                const grid = item.querySelector<HTMLElement>('.technology-stack__grid');

                if (!grid) return;

                const isOpen = item.classList.contains('is-open');

                if (isOpen) {
                    // Closing
                    grid.style.maxHeight = grid.scrollHeight + 'px';

                    requestAnimationFrame(() => {
                        grid.style.maxHeight = '0';
                    });

                    item.classList.remove('is-open');
                    trigger.classList.remove('is-open');
                } else {
                    // Opening
                    item.classList.add('is-open');
                    trigger.classList.add('is-open');
                    grid.style.maxHeight = grid.scrollHeight + 'px';
                }
            });
        });
    }
}
